"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountOverviewService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
class AccountOverviewService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.accountOverviewUrl = '/rest-api/customer/v1/overview';
        this.fiberAccountStatusUrl = '/rest-api/fiber/order/v1/statusbyId';
    }
    getPersonalInformation() {
        if (this.accountOverviewObservable) {
            return this.accountOverviewObservable;
        }
        else {
            this.accountOverviewObservable = this.get(this.accountOverviewUrl).pipe(operators_1.map((data) => {
                this.accountOverviewObservable = null;
                return data;
            })).pipe(operators_1.share());
            return this.accountOverviewObservable;
        }
    }
    getFiberAccountStatus(address, city, state, zip) {
        return this.get(this.fiberAccountStatusUrl + '?address=' + encodeURIComponent(address) + '&city=' + city + '&state=' + state + '&zip=' + zip).pipe(operators_1.map((data) => data));
    }
}
exports.AccountOverviewService = AccountOverviewService;
//# sourceMappingURL=accountoverview.service.js.map